import { ReactNode } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import { User } from '../../types';
import AnalyticsHeader from '../../widgets/Header';
import AdminSettings from './AdminSettings/AdminSettings';
import UserSettings from './UserSettings/UserSettings';

type SettingsPanelProps = {
  children: ReactNode;
};

interface RootState {
  user: {
    currentUser: User | null;
  };
}

const SettingsPanel = ({ children }: SettingsPanelProps) => {
  return (
    <div className="main-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12}>{children}</Col>
        </Row>
      </Container>
    </div>
  );
};

const Settings = () => {
  const userDetails = useSelector((state: RootState) => state.user.currentUser);
  const userRole = userDetails?.role;

  const tabRoutes = [
    ...(userRole === 'admin'
      ? [
          {
            title: 'Admin',
            path: 'admin',
            tabLink: '/settings/admin',
            element: <AdminSettings />
          }
        ]
      : []),
    {
      title: 'User',
      path: 'user',
      tabLink: '/settings/user',
      element: <UserSettings />
    }
  ];

  return (
    <div className="main-content">
      <AnalyticsHeader title="Settings" tabs={tabRoutes} />
      <Routes>
        {tabRoutes.map(({ path, element, title }) => (
          <Route key={title} path={path} element={<SettingsPanel>{element}</SettingsPanel>} />
        ))}
      </Routes>
    </div>
  );
};

export default Settings;
